import { render } from "./FalkenWarranty.html?vue&type=template&id=e995a7fc&scoped=true&ts=true&external"
import script from "./FalkenWarranty.ts?vue&type=script&lang=ts&external"
export * from "./FalkenWarranty.ts?vue&type=script&lang=ts&external"

import "./FalkenWarranty.scss?vue&type=style&index=0&id=e995a7fc&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e995a7fc"]])

export default __exports__